import { render } from "./FilterConfigModal.vue?vue&type=template&id=58c1c914"
import script from "./FilterConfigModal.vue?vue&type=script&lang=js"
export * from "./FilterConfigModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__